import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGES]: {
		url: '/company/:companyId/equipment/:equipmentId/pledges/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].GET_EQUIPMENT_PLEDGE]: {
		url: '/company/:companyId/equipment/:equipmentId/pledges/:pledgeId/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].CREATE_EQUIPMENT_PLEDGE]: {
		url: '/company/:companyId/equipment/:equipmentId/pledges/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PATCH_EQUIPMENT_PLEDGE]: {
		url: '/company/:companyId/equipment/:equipmentId/pledges/:pledgeId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].PUT_EQUIPMENT_PLEDGE]: {
		url: '/company/:companyId/equipment/:equipmentId/pledges/:pledgeId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_PLEDGES].DELETE_EQUIPMENT_PLEDGE]: {
		url: '/company/:companyId/equipment/:equipmentId/pledges/:pledgeId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
